import { opacify } from "@kraaft/shared/core/utils/colorsUtils";

export const getDisabledColor = (color: string) => opacify(color, 0.6);
export const getHoveredColor = (color: string, hovered = true) =>
  hovered ? opacify(color, 0.75) : color;
export const getPressedColor = (color: string) => opacify(color, 0.75);
